import { setTerm } from './helpers';

export const setSalesStart = setTerm('is_sales_start');
